import React, { useEffect, useState, useRef } from "react";
import BannerImage from "../SVGComponents/BannerImage";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import whiteYellowLogo from "../assets/images/whiteYellologo.svg";
import NewERPbg from '../../images/360 Degree Erp Logo.png';
import check from "../assets/images/check.png";
import { Link } from "react-router-dom";
import MasterService from "../../Masters/MasterService";
import Swal from "sweetalert2";
import Header from "./Header";
import { toast } from "../../NewUI/NewComponents/toastService";

const SignUp = () => {
  const is360 = process.env.REACT_APP_FINANZZ_URL === "360";
  const primaryColor = is360 ? "#390098" : "#062533";
  const appName = is360 ? "360\u00B0 ERP" : "FINANZZ ERP";
  const appDomain = is360 ? "360erp.in" : "finanzz.in";
  const logo = is360 ? NewERPbg : whiteYellowLogo;
  const [value, setValue] = useState("");
  const [country, setCountry] = useState(null);
  const [cities, setCities] = useState([]);
  const [city, setCity] = useState(null);
  const [countries, setcountries] = useState([]);
  const [currencies,setCurrencies] = useState([])
  const [error,setError] = useState("")
  // const [region, setRegion] = useState(null);
  // const [Formdata, setFormdata] = useState({
  //   firstName: "",
  //   lastName: "",
  //   companyName: "",
  //   companyNo: "",
  //   workEmail: "",
  //   phoneNo: "",
  //   subDomain: "",
  //   url: "",
  //   country: "",
  //   city: "",
  // });

  const [formdat, setformdat] = useState({ fname: '', lname: '', compname: '', GSTin: '', email: '', phno: '', subdomain: '', finanzurl: '', country: '', city: {}, check: false });

  useEffect(() => {
    MasterService
      .getCountries()
      .then((res) => setcountries(res?.data))
      .catch((err) => console.error("Error fetching countries: ", err))
    MasterService.GetAllCurrency()
      .then(res=>setCurrencies(res.data))

    // ERPServices
    // .getCityByCountryId(101)
    // .then((res) => console.log("COUNTRYBYID: ", res.data))
    // .catch((err) => console.error(err))
  }, [])


  // const schema = yup.object().shape({
  //   firstName: yup.string().min(2).max(30).required(),
  //   lastName: yup.string().min(2).max(30).required(),
  //   companyName: yup.string().min(2).max(30).required(),
  //   companyNo: yup.string().min(2).max(30).required(),
  //   workEmail: yup.string().email().required(),
  //   phoneNo: yup.string()
  //   .required('Phone number is required')
  //   .matches(
  //     /^\+?[1-9]\d{1,14}$/,
  //     'Phone number is not valid'
  //   ),
  //   subDomain: yup.string().min(2).max(30).required(),
  //   url: yup.string().min(2).max(30).required(),
  //   country: yup.string().min(2).max(30).required(),
  //   city: yup.string().min(2).max(30).required(),
  // });

  // const { control, handleSubmit, reset } = useForm({
  //   resolver: yupResolver(schema),
  // });

  const onSubmit = (data) => {
    console.log(data);
    reset();
    setCountry(null);
    setCity(null);
  };

  // Create a ref to store the form element
  const formRef = useRef(null);

  // Handle button click to trigger form submission
  // const handleButtonClick = () => {
  //   if (formRef.current) {
  //     formRef.current.requestSubmit(); // Trigger form submission
  //   }
  // };

  const handleonchange = (type, val) => {
    setError("")
    const curr = { ...formdat };
    curr[type] = val;
    if(type === "subdomain"){
      curr["finanzurl"] = `https://${val}.${appDomain}`
    }
    console.log("COCPC: ", curr);
    
    setformdat(curr);
  }

  const handleChange = (newValue, obj) => {
    setValue(newValue);
    // saveFormdata("phoneNo", `+${obj.countryCallingCode} ${obj.nationalNumber}`);
  };

  const valid = () =>{

   if(formdat?.compname && formdat?.fname && formdat?.lname && formdat?.subdomain && formdat?.email && formdat?.GSTin && formdat?.city?.countryid && formdat?.city?.stateid && formdat?.city?.id){
    if(formdat?.phno){
      if(formdat?.phno.split(" ").length ===2){
        return true
      }else{
        toast("Please enter phone no with country code separated by space","error")
        setError("Please enter phone no with country code separated by space")
      }
    }else{
      return true
    }
   }else{
    toast("Please fill all the mandatory fields","error")
   }
  }

  const handleSubmit = () => {
    // console.log("first: ", formdat?.phno?.slice(1, 4), "strlen: ", formdat?.phno?.length)

    if(valid()){

    const [is, ph1, ph2, ph3] = formdat?.phno?.split(" ");
    const [tr, isd] = is?.split("+");

    let payload = {
      "companyname": formdat?.compname,
      "contactname": `${formdat?.fname} ${formdat?.lname}`,
      "prefix": formdat?.subdomain,
      "contactnumber": `${ph1 ? ph1 : ''}${ph2 ? ph2 : ''}${ph3 ? ph3 : ''}`,
      "email": formdat?.email,
      "address": "",
      "address2": "",
      "pan": "",
      "tan": "",
      "gstin": formdat?.GSTin,
      "zip": "",
      // "zoneid": "Asia/Calcutta",
      "zoneid":null,
      "country": {
          "id": formdat?.city?.countryid
      },
      "state": {
          "id": formdat?.city?.stateid
      },
      "city": {
          "id": formdat?.city?.id
      },
      "fystartmonth": "",
      "fyendmonth": "",
      "currency": {
        id:currencies.find(e=>e.currency === formdat?.country?.currency)?.id || 10000001 
      },
      "taxtype": { id: 1 },
      "taxno": "",
      "registrationno": "",
      "logofile": "",
      "logopath": "",
      "alternatenumber": "",
      "phonecode": isd,
      "einvoice": false,
      "initialsetup":"Pending",
      "noofusers": 0,
      "refno": "",
      "clientType": "Individual",
      "parentclientId": "",
      "isWebsignup":true
  }

  console.log("PAYLOF: ", payload)

  MasterService
    .createTenant(payload).then((res)=>{
      if(res.data && res.data==="Success"){
        Swal.fire('','Your login credentials have been sent to your registered email address.','success').then(()=>{
        const url = `http://${payload.prefix}.${window.location.host}/login`
        window.location.href = url
      })
      }
    })
    .catch((err) => {
      console.log(err)
      if(err && err.response && err.response.data && err.response.data.message){
      Swal.fire('',err.response.data.message)
      }
    })
  }
}

  // const getCities = (value) => {
  //   const temp = countries_cities;
  //   //   const temp2 = temp[country?.label];
  //   const temp2 = temp[value];
  //   console.log(temp2);
  //   const temp3 = temp2?.map((val) => ({ label: val })) || [{ label: value }];
  //   console.log(country?.label, temp3);
  //   setCities(temp3);
  // };

  const getCities = (id) => {

    MasterService
    .getCityByCountryId(id)
    .then((res) => {
      console.log("RESDF: ", res?.data);
      // let p = [];

      // res?.data?.flatMap((es) => p.push(es))


      // console.log("HHJDD: ", p);
      // setCities(res?.data?.slice(0, 50))
      setCities(res?.data)
    })
    .catch((err) => console.error(err))

    // const temp = countries_cities;
    // //   const temp2 = temp[country?.label];
    // const temp2 = temp[value];
    // console.log(temp2);
    // const temp3 = temp2?.map((val) => ({ label: val })) || [{ label: value }];
    // console.log(country?.label, temp3);
    // setCities(temp3);
  };

  const saveFormdata = (name, value) => {
    // const temp = { ...Formdata };
    // temp[name] = value;
    // // setFormdata(temp);
    // console.log(temp);
  };

  // useEffect(() => {
  //   setWindowWidth(window.innerWidth);
  //   console.log("hello", window.innerWidth);
  // }, []);

  const bulletBeforeStyle = {
    content: '""',
    position: "absolute",
    left: "5px",
    top: "15px",
    transform: "translateY(-100%)",
    width: "18px",
    height: "18px",
    backgroundImage: `url(${check})`,
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
  };

  return (<>
    <section
    className={`tw-min-h-[100vh] tw-w-[100vw] tw-max-w-[100vw] SignUp ${is360 ? "tw-bg-gradient-to-r tw-from-[#1a0033] tw-via-[#390098] tw-to-[#7b3ed4]" : "tw-bg-gradient-to-r tw-from-[#042877] tw-via-[#154494] tw-to-[#4a89d7]"}`}
    style={{
      backgroundColor: is360 ? "linear-gradient(#1a0033, #390098, #5a1fb0, #7b3ed4)" : "linear-gradient(#042877, #154494, #2a61b1, #4a89d7)",
    }}
  >
     <Header is360={is360} primaryColor={primaryColor} logo={logo} />
    <div className="tw-flex max-lg:tw-flex-col max-lg:tw-justify-center max-lg:tw-items-center max-lg:tw-gap-6 tw-mt-10">
      <div className="tw-w-full md:tw-w-2/3 lg:tw-w-7/12">
        <div className="tw-w-full lg:tw-w-[30rem] tw-mx-auto max-lg:tw-mt-10">
          <BannerImage />
        </div>
        <div className="tw-mt-3 min-[1200px]:tw--mt-10 min-[1317px]:tw-mt-10 max-lg:tw-hidden min-[1200px]:tw-absolute min-[1317px]:tw-relative min-[1200px]:tw-w-[725px] max-[1317px]:tw-w-auto tw-mx-auto">
          <ul className="tw-list-none tw-p-0 tw-m-0 tw-flex tw-flex-wrap tw-gap-3 tw-justify-center">
            {[
              { title: "Data Accuracy", description: "Gain immediate insight into every facet of your business data." },
              { title: "Dashboard & Reports", description: "Comprehensive dashboard and detailed reports for enhanced ERP performance and insights." },
              { title: "Implementation Support", description: "Our domain experts assist you in implementing your business processes, ensuring a smooth transition as you adopt our ERP solution." },
              { title: "GST & VAT Compliance", description: `${appName} possesses the capability for E-invoicing, E-way Billing, and efficiently manages VAT taxation for various countries.` },
              { title: "Data Security & Privacy", description: `${appName} ensures data security with robust measures, protecting sensitive business information.` },
              { title: "Integrated Workflows", description: "Streamlined workflows seamlessly integrated for enhanced organizational efficiency." },
              { title: "Seamless Migration", description: "Effortlessly customize your ERP stack to incorporate a blend of SaaS, private cloud, and on-premise solutions tailored to your organization's requirements." },
              { title: "Industry Solution Best Practices", description: "Tailored to fit any industry domain while adhering to the industry best practices and future trends." },
            ].map((item, index) => (
              <li className="tw-relative tw-ps-7" key={index}>
                <span style={bulletBeforeStyle} />
                <h2 className="tw-headi ProductSansMedium tw-uppercase tw-text-sm tw-text-[#ffffff] tw-leading-[1] tw-w-[136px] tw-h-8">
                  {item.title}
                </h2>
                <p className="tw-para ProductSansRegular tw-text-[11px] tw-text-[#b3b3b3] tw-leading-[1.25] tw-tracking-tighter tw-w-36">
                  {item.description}
                </p>
              </li>
            ))}
          </ul>
        </div>
      </div>
  
      <div className="tw-w-4/5 lg:tw-w-5/12 tw-self-center tw-flex tw-flex-col tw-gap-10 2xl:tw-gap-16 ProductSansRegular md:tw-px-4">
        <h3 className="ProductSansMedium tw-text-white tw-text-2xl 2xl:tw-mt-20 max-lg:tw-text-center">
          Account SignUp!
        </h3>
  
        <form ref={formRef} noValidate>
          <div className="tw-flex tw-flex-wrap tw-gap-[6px] tw-justify-center">
            {[
              { name: "fname", label: "First Name", placeholder: "John" },
              { name: "lname", label: "Last Name", placeholder: "Jacob" },
              { name: "compname", label: "Company Name", placeholder: "Falcon Industries Pvt Ltd" },
              { name: "GSTin", label: "Company GST/VAT", placeholder: "2ABBEC678DDCZ1" },
              { name: "email", label: "Work Email", placeholder: "john.jacob@falcon.com" },
              { name: "phno", label: "Phone No", placeholder: "+91 9999999999" },
              { name: "subdomain", label: "Choose Subdomain", placeholder: is360 ? "NANO.360ERP.IN" : "NANO.XXXX.IN" },
              { name: "finanzurl", label: `Your ${appName} URL`, placeholder: `https://nano.${appDomain}`, disabled: true },
            ].map((input, index) => (
              <TextField
                key={index}
                className="tw-w-full xs:tw-w-4/5 md:tw-w-[49.2%] tw-rounded-md"
                sx={{ mb: "4px" }}
                placeholder={input.placeholder}
                size="small"
                required={input.name !=="phno"}
                id={`outlined-required-${input.name}`}
                label={input.label}
                name={input.name}
                onChange={(ev) => handleonchange(ev.target.name, ev.target.value)}
                value={formdat[input.name]}
                disabled={input.disabled || false}
              />
            ))}
  
            {/* <MuiTelInput
              className="tw-w-full xs:tw-w-4/5 md:tw-w-[49.2%] tw-rounded-md"
              sx={{ mb: "4px" }}
              size="small"
              defaultCountry="IN"
              label="Phone No *"
              name="phno"
              onChange={(ev) => handleonchange("phno", ev)}
              value={formdat.phno}
            /> */}
  
            <Autocomplete
              className="tw-w-full xs:tw-w-4/5 md:tw-w-[49.2%] tw-rounded-md tw-cursor-pointer"
              sx={{ mb: "4px" }}
              size="small"
              id="country-select-demo"
              options={countries}
              autoHighlight
              getOptionLabel={(option) => option.name}
              onChange={(e, val) => {
                if(val && typeof val === 'object'){
                setCountry(val);
                getCities(val.id);
                setCity(null);
                handleonchange("country", val?.name);
                }else{
                  setCountry();
                  setCities([]);
                  setCity(null);
                  handleonchange("country", "")
                }
              }}
              value={country}
              renderInput={(params) => (
                <TextField {...params} label="Choose a country *" inputProps={{ ...params.inputProps, autoComplete: "new-password" }} />
              )}
            />
  
            <Autocomplete
              className="tw-w-full xs:tw-w-4/5 md:tw-w-[49.2%] tw-rounded-md"
              sx={{ mb: "4px", opacity: country ? 1 : 0.5 }}
              size="small"
              id="city-select-demo"
              disabled={!country}
              options={cities}
              getOptionLabel={(option) => `${option.name}, ${option.state}`}
              value={city}
              onChange={(e, val) => {
                if(val && typeof val ==="object"){
                setCity(val);
                handleonchange("city", val);
                }else{
                  setCity()
                  handleonchange("city", null);
                }
              }}
              renderInput={(params) => (
                <TextField {...params} label="Choose a city *" inputProps={{ ...params.inputProps, autoComplete: "new-password" }} />
              )}
            />
          </div>
        </form>
  
        <div className="tw-flex tw-flex-col tw-items-center tw-gap-3 2xl:tw-gap-4">
          <div className="tw-flex tw-gap-3">
            <input
              className="tw-w-5 2xl:tw-w-[22px] tw-h-5 2xl:tw-h-[22px] tw-accent-[#fdd60e] tw-cursor-pointer tw-my-auto"
              type="checkbox"
              checked={formdat?.check}
              name="check"
              onChange={(ev) => handleonchange(ev.target.name, ev.target.checked)}
            />
            <p
              onClick={() => handleonchange("check", !formdat?.check)}
              className="tw-cursor-pointer tw-text-white tw-text-[14px] tw-xl:text-[15px] max-lg:tw-tracking-tighter tw-xl:tracking-wide"
            >
              I agree to {appName}.in{" "}
              <span className="tw-underline tw-cursor-pointer tw-hover:text-[#fdd60e] tw-active:text-white">Privacy Policy</span> &{" "}
              <span className="tw-underline tw-cursor-pointer tw-hover:text-[#fdd60e] tw-active:text-white">Terms of Service</span>.
            </p>
          </div>
          <div className="tw-text-red-600 tw-text-xs">{error}</div>
          <button
            disabled={!formdat?.check}
            className={`tw-text-black ProductSansMedium ${formdat?.check ? "tw-bg-[#fdd60e] tw-hover:scale-[1.02] tw-active:translate-y-2 " : "tw-bg-gray-300 tw-cursor-not-allowed"} tw-px-8 2xl:tw-px-14 tw-py-2 2xl:tw-py-3 tw-rounded-md tw-shadow-[4.7px_9.4px_9.4px_rgba(0,0,0,0.20)] tw-transition tw-duration-300 tw-ease-in-out tw-cursor-pointer focus:tw-outline-none`}
            onClick={handleSubmit}
          >
            Create Account
          </button>
  
          <Link to="/clientlogin">
            <p className="tw-text-white">
              Already have an account?{" "}
              <span className="tw-underline tw-hover:text-[#fdd60e] tw-active:text-white">Login</span>
            </p>
          </Link>
          
        </div>
      </div>
    </div>
  </section>
  </>);
};

export default SignUp;
